/* Bella K Relaunch: „So einfach geht’s.“ (bkr-steps). Clips laufen stumm im Loop, nur solange sie im Bild sind.
   Reduced Motion: kein Autoplay (Poster bleibt stehen). */
window.bkr.section('.s-steps', function (root) {
  var vids = window.bkr.$$('[data-step-video]', root);
  if (!vids.length || window.bkr.reduce || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (x) {
      var v = x.target;
      if (x.isIntersecting) {
        if (v.preload === 'none') v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.25 });
  vids.forEach(function (v) { io.observe(v); });
  return function () { io.disconnect(); vids.forEach(function (v) { v.pause(); }); };
});
